export const langObj = {
    "arm": "AM",
    "eng": "ENG",
    "ru": "RU",
}